import React from 'react';
import factory from 'components/Icons/factory';

export const Play = factory('Play', <path d="M96.1 64L42.3 32v64z" />);

export default Play;
